import React, { useState, useRef } from 'react';
import './three.css';

const imageSets = {
  green: ['00.webp', '01.webp', '02.webp', '03.webp', '04.webp', '05.webp', '06.webp', '07.webp']
    .map(img => require(`../assets/img/green/${img}`)),
  blue: ['00.png', '01.png', '02.png', '03.png', '04.png', '05.png', '06.png', '07.png']
    .map(img => require(`../assets/img/blue/${img}`)),
  yellow: ['00.png', '01.png', '02.png', '03.png', '04.png', '05.png', '06.png', '07.png']
    .map(img => require(`../assets/img/yellow/${img}`)),
  red: ['00.png', '01.png', '02.png', '03.png', '04.png', '05.png', '06.png', '07.png']
    .map(img => require(`../assets/img/red/${img}`)),
};

const specsData = {
  CNG: [
    { icon: 'displacement.png', title: 'Engine Displacement', value: '236.2 cc' },
    { icon: 'net-power.png', title: 'Maximum Net Power', value: '7.45 kW' },
    { icon: 'tray-size.png', title: 'Dimensions (Tray Size)', value: 'Length - 1840 mm, Width - 1425 mm' },
    { icon: 'fuel-tank.png', title: 'Fuel Tank Capacity', value: '40 L' },
    { icon: 'clutch.png', title: 'Clutch Type', value: 'Wet, Multiplate' },
    { icon: 'drive-shaft.png', title: 'Drive Shaft', value: 'CV shaft' }
  ],
  Diesel: [
    { icon: 'displacement.png', title: 'Engine Displacement', value: '470.5 cc' },
    { icon: 'net-power.png', title: 'Maximum Net Power', value: '6.43 kW' },
    { icon: 'tray-size.png', title: 'Dimensions (Tray Size)', value: 'Length - 1840 mm, Width - 1425 mm' },
    { icon: 'fuel-tank.png', title: 'Fuel Tank Capacity', value: '8 L' },
    { icon: 'clutch.png', title: 'Clutch Type', value: 'Dry, Singleplate' },
    { icon: 'drive-shaft.png', title: 'Drive Shaft', value: 'CV shaft' }
  ]
};

const Vehicle360Card = () => {
  const [index, setIndex] = useState(0);
  const [color, setColor] = useState('green');
  const [variant, setVariant] = useState('CNG');

  const isDragging = useRef(false);
  const lastX = useRef(null);

  const handleMouseDown = (e) => {
    isDragging.current = true;
    lastX.current = e.clientX;
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current) return;

    const deltaX = e.clientX - lastX.current;
    if (Math.abs(deltaX) > 5) {
      setIndex((prevIndex) => {
        const nextIndex = deltaX > 0 ? prevIndex - 1 : prevIndex + 1;
        const images = imageSets[color];
        return (nextIndex + images.length) % images.length;
      });
      lastX.current = e.clientX;
    }
  };

  const handleMouseUp = () => {
    isDragging.current = false;
    lastX.current = null;
  };

  const handleTouchStart = (e) => {
    lastX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    const currentX = e.touches[0].clientX;
    const deltaX = currentX - lastX.current;
    if (Math.abs(deltaX) > 5) {
      setIndex((prevIndex) => {
        const nextIndex = deltaX > 0 ? prevIndex - 1 : prevIndex + 1;
        const images = imageSets[color];
        return (nextIndex + images.length) % images.length;
      });
      lastX.current = currentX;
    }
  };

  return (
    <>
      <div className="vehicle-card">
        <div className="vehicle-layout">
          {/* 360° Viewer */}
          <div
            className="vehicle-viewer"
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleMouseUp}
          >
            <img
              src={imageSets[color][index]}
              alt="360 view"
              className="vehicle-image"
              draggable={false}
            />
          </div>

          {/* Specs Panel */}
          <div className="vehicle-details">
            {specsData[variant].map((spec, i) => (
              <div className="spec-row" key={i}>
                <img
                  src={require(`../assets/icons/${spec.icon}`)}
                  alt={spec.title}
                  className="spec-icon"
                />
                <div>
                  <p className="specsTitle">{spec.title}</p>
                  <p className="specsText">{spec.value}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Color Selector */}
        <div className="color-selector">
          {Object.keys(imageSets).map((col) => (
            <span
              key={col}
              style={{ backgroundColor: col }}
              className={`color-dot ${color === col ? 'active' : ''}`}
              onClick={() => setColor(col)}
            ></span>
          ))}
        </div>
      </div>

      {/* Variant Tabs */}
      <div className="variant-tabs">
        {Object.keys(specsData).map((v) => (
          <button
            key={v}
            onClick={() => setVariant(v)}
            className={variant === v ? 'active' : ''}
          >
            {v}
          </button>
        ))}
      </div>
    </>
  );
};

export default Vehicle360Card;
